import { Component, Input, OnInit, inject } from '@angular/core';
import { DomSanitizer, type SafeHtml } from '@angular/platform-browser';
import { BoDialogComponent } from '@3ddv/software-division-components/backoffice/dialog';
import { ButtonComponent } from '@3ddv/software-division-components/generic/button';
import { BrnDialogRef } from '@spartan-ng/brain/dialog';

@Component({
  selector: 'app-emails-modal',
  templateUrl: './emails.component.html',
  styleUrls: ['./emails.component.css'],
  imports: [BoDialogComponent, ButtonComponent],
})
export class EmailsModalComponent implements OnInit {
  private dialogRef = inject<BrnDialogRef<void>>(BrnDialogRef);
  private domSanitizer = inject(DomSanitizer);

  @Input() data: string;

  public templateHtml: SafeHtml;

  ngOnInit(): void {
    if (this.data) {
      this.templateHtml = this.domSanitizer.bypassSecurityTrustHtml(this.data);
    }
  }

  public onClose() {
    this.dialogRef.close();
  }
}
